export function opacityToHex(opacity) {
  if (opacity < 0 || opacity > 1) {
    throw new Error("Opacity must be between 0 and 1");
  }
  var hex = Math.round(opacity * 255).toString(16).toUpperCase();
  return hex.padStart(2, "0");
}